export default __webpack_public_path__ + "static/hero-9714e9d4868944db630ebfb5fb3db252.png";